/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinusCircle, faPencil } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import useEducationalInformation from "./useEducationalInformation";
import { dateFormatter } from "../../../../_helpers/dateFormatter";

export default (props) => {
  const {
    allEducationalData,
    loadingEducation,
    educationFormData,
    editEducationItemId,
    degree,
    newEducationAdded,

    onEducationFormDataChange,
    onSubmitForm,
    deleteUserEducation,
    onDateChange,
    onEditEducationItemClick,
    onEditEducationCancelClick,
    onAddNewEducationClick,
    onNewEducationCancelClick,
  } = useEducationalInformation(props);

  return (
    <div className="hiring-process-dashboard  hiring-manager-profile-wrapper">
      <div className="job-detail-wrapper mt-4 pr-lg-4">
        <Container>
          <Row>
            <div className="col-md-8 bg-white border-radius-10 border p-4">
                <h2 className="mb-3">Education</h2>

              <div>
                {loadingEducation ? (
                  <div className="d-flex justify-content-center align-items-center">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  allEducationalData &&
                  Array.isArray(allEducationalData) &&
                  allEducationalData.map((item) => (
                    <div
                      className="py-2 position-relative"
                      key={item?.id}
                    >
                      {editEducationItemId === item?.id ? (
                        <Row>
                          <Col lg={5}>
                            <div className="form-group">
                              <p className="font-weight-medium">
                                <span className="text-danger">* </span>College
                                Name
                              </p>
                              <input
                                className="form-control mw-100 text-capitalize"
                                type="text"
                                placeholder="Enter your College Name"
                                name={"school"}
                                defaultValue={educationFormData?.school_name}
                                onChange={onEducationFormDataChange}
                              />
                            </div>
                          </Col>
                          <Col lg={5}>
                            <div className="form-group">
                              <p className="font-weight-medium">
                                <span className="text-danger">* </span>Degree
                              </p>
                              <input
                                className="form-control mw-100 text-capitalize"
                                type="text"
                                placeholder="Enter your Degree"
                                name={"college_degree"}
                                defaultValue={
                                  educationFormData?.college_degree_name
                                }
                                onChange={onEducationFormDataChange}
                              />
                            </div>
                          </Col>

                          <Col lg={5}>
                            <div className="form-group">
                              <p className="font-weight-medium">Degree Type</p>
                              <span className="select">
                                <select
                                  className="form-control bg-transparent text-capitalize"
                                  name={"degree_type"}
                                  onChange={onEducationFormDataChange}
                                >
                                  <option
                                    disabled={true}
                                    value=""
                                    selected={
                                      educationFormData?.degree_type === null
                                    }
                                  >
                                    Select Degree Type
                                  </option>
                                  {Array.isArray(degree) &&
                                    degree.map((i) => (
                                      <option
                                        key={i.key}
                                        selected={
                                          educationFormData?.degree_type ===
                                          i.value
                                        }
                                        value={i.value}
                                      >
                                        {i.key}
                                      </option>
                                    ))}
                                </select>
                              </span>
                            </div>
                          </Col>
                          <Col lg={5}>
                            <div className="form-group">
                              <p className="font-weight-medium">
                                Field of Study
                              </p>
                              <input
                                className="form-control mw-100 text-capitalize"
                                type="text"
                                placeholder="Enter your Field Of Study"
                                name={"field_of_study"}
                                defaultValue={
                                  educationFormData?.field_of_study_name
                                }
                                onChange={onEducationFormDataChange}
                              />
                            </div>
                          </Col>

                          <Col lg={5}>
                            <div className="form-group">
                              <p className="font-weight-medium">Start Date</p>
                              <DatePicker
                                onChange={(date) => {
                                  onDateChange(date, "start_date");
                                }}
                                className="form-control bg-transparent"
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                value={
                                  educationFormData?.start_date
                                    ? educationFormData.start_date
                                        .split("-")
                                        .reverse()
                                        .join("-")
                                    : null
                                }
                                placeholderText={
                                  educationFormData?.start_date
                                    ? educationFormData.start_date
                                        .split("-")
                                        .reverse()
                                        .join("-")
                                    : "Select Start Date"
                                }
                              />
                            </div>
                          </Col>

                          <Col lg={5}>
                            <div className="form-group">
                              <p className="font-weight-medium">End Date</p>
                              <DatePicker
                                onChange={(date) => {
                                  onDateChange(date, "end_date");
                                }}
                                className="form-control bg-transparent"
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                value={
                                  educationFormData?.end_date
                                    ? educationFormData.end_date
                                        .split("-")
                                        .reverse()
                                        .join("-")
                                    : null
                                }
                                placeholderText={
                                  educationFormData?.end_date
                                    ? educationFormData.end_date
                                        .split("-")
                                        .reverse()
                                        .join("-")
                                    : "Select End Date"
                                }
                              />
                            </div>
                          </Col>

                          {/* <Col lg={5}>
                            <div className="form-group">
                              <p className="font-weight-medium">
                                Upload Degree
                              </p>
                              <input
                                type="file"
                                className="form-control mw-100 text-capitalize"
                                placeholder="Upload Degree"
                              />
                            </div>
                          </Col> */}
                          <Col lg={12}>
                            <div className="form-group d-flex align-items-center">
                              <button
                                className="btn btn-primary"
                                onClick={() => onSubmitForm()}
                              >
                                Save
                              </button>
                              <button
                                className="btn btn-light ml-3"
                                onClick={onEditEducationCancelClick}
                              >
                                Cancel
                              </button>
                              <button
                                className="border-0 bg-transparent text-danger ml-auto"
                                onClick={() => deleteUserEducation(item.id)}
                              >
                                <FontAwesomeIcon
                                  icon={faMinusCircle}
                                  className="mr-2"
                                />
                                Delete Education
                              </button>
                            </div>
                          </Col>
                        </Row>
                      ) : (
                        <div className="border border-radius-10 p-4 bg-grey-5  text-capitalize">
                          <div className="d-flex align-items-start justify-content-between">
                            <div>
                              <h3 className="font-weight-medium fs-20 mb-1">{item?.college_degree_name}</h3>
                              <p className="text-grey-4">{item?.school_name}</p>
                              <span className="text-grey-4 mr-2">{item?.degree_type.replace(/_/g , " ")}</span>{"|"}{" "}
                              <span className="text-grey-4">{dateFormatter(item?.start_date)}</span> -
                              <span className="text-grey-4"> {dateFormatter(item?.end_date)}</span>
                            </div>
                            <FontAwesomeIcon
                              icon={faPencil}
                              className="text-grey-4 cursor-pointer"
                              onClick={() => onEditEducationItemClick(item?.id)}
                            />
                            </div>
                          </div> 
                      )}
                    </div>
                  ))
                )}

                {newEducationAdded && (
                  <div className="py-3 mb-4">
                    <Row>
                      <Col lg={5}>
                        <div className="form-group">
                          <p className="font-weight-medium">
                            <span className="text-danger">* </span>College Name 
                          </p>
                          <input
                            className="form-control mw-100 text-capitalize"
                            type="text"
                            placeholder="Enter your College Name"
                            name={"school"}
                            defaultValue={educationFormData?.school_name}
                            onChange={onEducationFormDataChange}
                          />
                        </div>
                      </Col>
                      <Col lg={5}>
                        <div className="form-group">
                          <p className="font-weight-medium">
                            <span className="text-danger">* </span>Degree
                          </p>
                          <input
                            className="form-control mw-100 text-capitalize"
                            type="text"
                            placeholder="Enter your Degree"
                            name={"college_degree"}
                            defaultValue={
                              educationFormData?.college_degree_name
                            }
                            onChange={onEducationFormDataChange}
                          />
                        </div>
                      </Col>

                      <Col lg={5}>
                        <div className="form-group">
                          <p className="font-weight-medium">Degree Type</p>
                          <span className="select">
                            <select
                              className="form-control bg-transparent text-capitalize"
                              name={"degree_type"}
                              onChange={onEducationFormDataChange}
                            >
                              <option
                                disabled={true}
                                value=""
                                selected={
                                  educationFormData?.degree_type === null
                                }
                              >
                                Select Degree Type
                              </option>
                              {Array.isArray(degree) &&
                                degree.map((i) => (
                                  <option
                                    key={i.key}
                                    selected={
                                      educationFormData?.degree_type === i.value
                                    }
                                    value={i.value}
                                  >
                                    {i.key}
                                  </option>
                                ))}
                            </select>
                          </span>
                        </div>
                      </Col>
                      <Col lg={5}>
                        <div className="form-group">
                          <p className="font-weight-medium">Field of Study</p>
                          <input
                            className="form-control mw-100 text-capitalize"
                            type="text"
                            placeholder="Enter your Field Of Study"
                            name={"field_of_study"}
                            defaultValue={
                              educationFormData?.field_of_study_name
                            }
                            onChange={onEducationFormDataChange}
                          />
                        </div>
                      </Col>

                      <Col lg={5}>
                        <div className="form-group">
                          <p className="font-weight-medium">Start Date</p>
                          <DatePicker
                            onChange={(date) => {
                              onDateChange(date, "start_date");
                            }}
                            className="form-control bg-transparent"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            value={
                              educationFormData?.start_date
                                ? educationFormData.start_date
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                : null
                            }
                            placeholderText={
                              educationFormData?.start_date
                                ? educationFormData.start_date
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                : "Select Start Date"
                            }
                          />
                        </div>
                      </Col>

                      <Col lg={5}>
                        <div className="form-group">
                          <p className="font-weight-medium">End Date</p>
                          <DatePicker
                            onChange={(date) => {
                              onDateChange(date, "end_date");
                            }}
                            className="form-control bg-transparent"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            value={
                              educationFormData?.end_date
                                ? educationFormData.end_date
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                : null
                            }
                            placeholderText={
                              educationFormData?.end_date
                                ? educationFormData.end_date
                                    .split("-")
                                    .reverse()
                                    .join("-")
                                : "Select End Date"
                            }
                          />
                        </div>
                      </Col>

                      {/* <Col lg={5}>
                        <div className="form-group">
                          <p className="font-weight-medium">Upload Degree</p>
                          <input
                            type="file"
                            className="form-control mw-100 text-capitalize"
                            placeholder="Degree"
                          />
                        </div>
                      </Col> */}
                      <Col lg={12}>
                        <div className="form-group d-flex align-items-center">
                          <button
                            className="btn btn-primary"
                            onClick={() => onSubmitForm()}
                          >
                            Save
                          </button>
                          <button
                            className="btn btn-light ml-3"
                            onClick={onNewEducationCancelClick}
                          >
                            Cancel
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}

                {!newEducationAdded && (
                  <p
                    className="text-primary cursor-pointer font-weight-medium mt-2"
                    onClick={() => onAddNewEducationClick()}
                  >
                    + Add New Education
                  </p>
                )}
              </div>
            </div>
          </Row> 
        </Container>
      </div>
    </div>
  );
};
